<template>
  <div class="student-block">
    <div v-if="studentSts === 1 && canOperateData" class="deal-block">
      <div class="student-search">
        <span>学生姓名：</span>
        <Input
          v-model="studentName"
          clearable
          placeholder="请输入学生姓名"
          style="width: 200px; margin-right: 30px"
          @on-clear="initList"
        ></Input>
        <span>年级班级：</span>
        <Cascader
          v-model="classData"
          clearable
          :data="gradeAndClassList"
          change-on-select
          placeholder="请选择年级班级"
        ></Cascader>
        <Button
          type="primary"
          class="search-btn"
          @click="initList"
        >搜索</Button>
      </div>
      <!-- <span class="click-btn-430" @click="handleAddRemarks">添加备注</span> -->

      <span class="click-btn-430" @click="handleLeaveStudents">离班</span>
      <span class="click-btn-430" @click="handleChangeStudents">转班</span>
    </div>
    <div v-if="studentSts === 0 && canOperateData" class="deal-block">
      <div class="student-search">
        <span>学生姓名：</span>
        <Input
          v-model="studentName"
          clearable
          placeholder="请输入学生姓名"
          style="width: 200px; margin-right: 30px"
          @on-clear="initList"
        ></Input>
        <span>年级班级：</span>
        <Cascader
          v-model="classData"
          clearable
          :data="gradeAndClassList"
          change-on-select
          placeholder="请选择年级班级"
        ></Cascader>
        <Button
          type="primary"
          class="search-btn"
          @click="initList"
        >搜索</Button>
      </div>

      <!-- <span class="click-btn-430" @click="handleAddRemarks">添加备注</span> -->
    </div>
    <div class="table-box">
      <Table
        ref="studentTable"
        border
        :columns="studentsColumn"
        :data="studentsData"
        :loading="loadingStudent"
        @on-row-click="selectRow"
        @on-select="pickOneStudent"
        @on-select-cancel="cancelOneStudent"
        @on-select-all="pickAllStudent"
        @on-select-all-cancel="cancelAllStudent"
      >
        <template slot="gradeName" slot-scope="{ row }">
          <span>{{ row.gradeName }}{{ row.className }}</span>
        </template>
        <template slot="status">
          <span>已报名</span>
        </template>
        <!-- <template slot="registeredTimeShow" slot-scope="{ row }">
          <div>{{ row.registeredTimeShow }}</div>
        </template> -->
        <template slot="leaveTime" slot-scope="{ row }">
          <div>{{ row.leaveTime }}</div>
        </template>
      </Table>
      <div class="page-main" style="padding-bottom: 180px">
        <Page
          :total="pageInfo.total"
          show-total
          :current="pageInfo.pageNum"
          class="page-right"
          show-sizer
          :page-size-opts="pageSizeOpts"
          :page-size="pageSize"
          @on-change="handlePage"
          @on-page-size-change="onPageSizeChange"
        ></Page>
      </div>
    </div>
    <!-- 设置入班时间弹窗 start  -->
    <Modal
      v-model="toClassShow"
      title="设置入班时间"
      :width="500"
      :footer-hide="true"
      :closable="false"
    >
      <span class="modal-tips">中途插班的学生需设置入班时间，系统将根据入班时间为孩子生成课表与考勤纪录</span>
      <div class="select-box">
        <span>学生入班时间：</span>
        <DatePicker
          type="date"
          placeholder="选择开始日期"
          style="width: 200px"
        ></DatePicker>
      </div>
      <div class="modal-footer">
        <Button @click="handleCloseClassTime">取消</Button>
        <Button type="primary">确定</Button>
      </div>
    </Modal>
    <!-- 设置入班时间弹窗 end  -->
    <!-- 修改上课时间弹窗 start  -->
    <Modal
      v-model="attendClassShow"
      title="修改上课时间"
      :width="500"
      :footer-hide="true"
      :closable="false"
    >
      <span class="modal-tips">可以至设置孩子仅部分周期日上课，修改后系统将自动更新孩子课表</span>
      <div class="select-box">
        <CheckboxGroup v-model="selectWeekGroup">
          <Checkbox
            v-for="(item, index) in weekList"
            :key="index"
            :label="item.name"
          ></Checkbox>
        </CheckboxGroup>
      </div>
      <div class="modal-footer">
        <Button @click="handleCloseAttenTime">取消</Button>
        <Button type="primary">确定</Button>
      </div>
    </Modal>
    <!-- 修改上课时间弹窗 end  -->
    <!-- 添加备注弹窗 start  -->
    <Modal
      v-model="remarksShow"
      title="添加备注"
      :width="500"
      :footer-hide="true"
      :closable="false"
    >
      <div class="select-box">
        <Input
          v-model="remarks"
          maxlength="20"
          show-word-limit
          type="textarea"
          placeholder="请输入备注"
        ></Input>
      </div>
      <div class="modal-footer">
        <Button @click="handleCloseRemarksModal">取消</Button>
        <Button
          type="primary"
          :loading="remarkLoading"
          @click="handleToRemarkTrue"
        >确定</Button>
      </div>
    </Modal>
    <!-- 添加备注弹窗 end  -->
    <!-- 学生离班组件 -->
    <LeaveClassModal
      ref="leaveClassModal"
      :classroom-id="classroomId"
      @leaveSuccess="leaveSuccess"
    ></LeaveClassModal>

    <!-- 学生转班组件 -->
    <ChangeClassDrawerContent
      ref="changeClassDrawerContent"
      :school-id="schoolId"
      :rel-classroom-id="relClassroomId"
      :classroom-id="classroomId"
      :cache-year-terms="cacheYearTerms"
      @refreshList="leaveSuccess"
    ></ChangeClassDrawerContent>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import ChangeClassDrawerContent from './ChangeClassDrawerContent.vue';
import LeaveClassModal from './LeaveClassModal.vue';
import { timeToYearStr, transferDate, formatTime } from '@/utils/utils.js';
import common from '@/request/common/index.js';
export default {
  components: {
    ChangeClassDrawerContent,
    LeaveClassModal
  },
  filters: {
    // 排课类型
    ruleTypeCh(ruleType) {
      let str = '';
      switch (Number(ruleType)) {
        case 1:
          str = '每周循环';
          break;
        case 2:
          str = '指定上课周';
          break;
        default:
          break;
      }
      return str;
    }
  },
  props: {
    // 当前分班所属的学校
    schoolId: {
      type: String,
      default: ''
    },
    classroomId: {
      type: String,
      default: ''
    },
    relClassroomId: {
      type: String,
      default: ''
    },
    studentSts: {
      type: Number,
      default: -1 // 1:在读学生 0：离班学生
    },
    // 学生基本信息
    classDateBegin: {
      type: String,
      default: ''
    },
    // 是否可以操作数据
    canOperateData: {
      type: Boolean,
      default: false
    },
    termCode: {
      type: [Number, String],
      default: ''
    },
    yearCode: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100],
      pageSize: 10,
      studentsColumn: [],
      // 入班表格的表头
      studentsColumnIn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '学号',
          key: 'studentSort',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '年级班级',
          slot: 'gradeName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '报名状态',
          slot: 'status',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '上课时间',
          key: 'classesTimeDesc',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '入班时间',
          key: 'registeredTimeShow',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 120,
          align: 'center'
        }
      ],
      // 离班表格的表头
      studentsColumnLeave: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '学号',
          key: 'studentSort',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '年级班级',
          slot: 'gradeName',
          minWidth: 120,
          align: 'center'
        },
        // {
        //   title: '年级',
        //   key: 'gradeName',
        //   minWidth: 120,
        //   align: 'center'
        // },
        // {
        //   title: '班级',
        //   key: 'className',
        //   minWidth: 120,
        //   align: 'center'
        // },
        {
          title: '报名状态',
          slot: 'status',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '上课时间',
          key: 'classesTimeDesc',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '入班时间',
          key: 'registeredTimeShow',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '离班时间',
          slot: 'leaveTime',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 120,
          align: 'center'
        }
      ],
      studentsData: [],
      pageInfo: {
        total: 1,
        pageSize: 10,
        pageNum: 1
      },
      toClassShow: false, // 是否展示入班时间弹窗
      attendClassShow: false, // 是否展示修改上课时间弹窗
      remarksShow: false, // 是否展示添加备注弹窗
      remarkLoading: false, // 添加备注弹窗是否loading
      studentsLeaveShow: false, // 学生离班弹窗
      studentsLeaveLoading: false, // 学生离班是否loading
      changeStudentsShow: false, // 学生转班弹窗
      changeStudentsLoading: false, // 学生转班是否loading
      weekList: [
        {
          name: '周一',
          value: 1
        },
        {
          name: '周二',
          value: 2
        },
        {
          name: '周三',
          value: 3
        },
        {
          name: '周四',
          value: 4
        },
        {
          name: '周五',
          value: 5
        },
        {
          name: '周六',
          value: 6
        },
        {
          name: '周日',
          value: 7
        }
      ],
      selectWeekGroup: [], // 选择的时间列表
      remarks: '', // 添加的备注
      selectStudentData: [], // 选择的学生
      changeFormValidate: {
        classId: '', // 选择关联的班级
        classTime: '', // 上课时间
        classRule: '', // 排课规则
        classTeacher: '', // 授课教师
        classPlace: '', // 上课地点
        classHour: '' // 待消课时
      }, // 学生转班的表单
      classroomList: [], // 可转班的课班
      loading: false,
      beginDateOption: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      nowDate: '', // 当前日期
      leaveClassDate: '', // 离班时间
      changeClassDate: '', // 转班时间
      loadingStudent: false, // 是否在请求学生列表数据
      studentName: '', // 学生姓名
      timeToYearStr: timeToYearStr,
      tabActive: 0, // 转班哪个tab选中
      changeTabList: ['同课程班级', '同价格的其他课程班级'],
      leaveData: [],
      leaveClassInfoList: [], // 离班学生数据
      selectLeaveIndex: 0,
      gradeAndClassList: [], // 年级班级数据
      classData: [], // 选择的年级班级
      classTimeList: [], // 课程节次日期
      endClassTime: '' // 课程截止时间
    };
  },
  computed: {
    pickerOptions() {
      const that = this;
      return {
        cellClassName: (time) => {
          if (that.classTimeList.length === 0) {
            return '';
          }
          const tag = that.classTimeList.findIndex(item => {
            return item === formatTime(time.getTime());
          });
          return tag > -1 ? 'date-red' : '';
        },
        disabledDate: (time) => {
          if (that.endClassTime) {
            return time.getTime() >= new Date(that.endClassTime).getTime();
          } else {
            return true;
          }
        }
      };
    },
    cacheYearTerms() {
      if (!this.yearCode) {
        return [];
      }
      return [+this.yearCode, this.termCode + ''];
    }
  },
  watch: {
    schoolId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getGradeAndClass();
        }
      }
    }
  },
  created() {
    this.dealColumn();
    this.getToday();
  },
  mounted() {
    this.getStudentsList();
    this.getClassTimes();
  },
  methods: {
    // 获取上课节次
    async getClassTimes() {
      const params = {
        classroomId: this.classroomId,
        teacherId: 0
      };
      const res = await courseSchedulCenter.getDetailWithTeaSign(params);
      if (res.status === 200) {
        this.classTimeList = res.message.map(item => {
          return item.classTimeBegin.split(' ')[0];
        });
        this.endClassTime = `${res.message[res.message.length - 1].classTimeBegin.split(' ')[0]} 00:00:00`;
      }
    },
    dealPickerOptions() {

    },
    // 请求年级班级列表
    async getGradeAndClass() {
      const params = {
        schoolId: this.schoolId
      };
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    getToday() {
      this.nowDate = transferDate(new Date());
      this.leaveClassDate = `${this.nowDate} 00:00:00`;
    },
    // 根据不同状态添加不同的表头字段
    dealColumn() {
      if (this.studentSts === 0) {
        this.studentsColumn = this.studentsColumnLeave;
      } else {
        this.studentsColumn = this.studentsColumnIn;
      }
    },
    initList() {
      this.pageInfo = {
        total: 1,
        pageSize: this.pageSize,
        pageNum: 1
      };
      this.selectStudentData = [];
      this.getStudentsList();
    },
    // 点击分页
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getStudentsList();
    },
    onPageSizeChange(size) {
      this.pageSize = size;
      this.initList();
      console.log(size);
    },
    // 获取学生列表
    async getStudentsList() {
      const params = {
        classroomId: this.classroomId,
        studentSts: this.studentSts, // 在读状态 0-离班 1-在读
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        studentName: this.studentName,
        isSearchEnrollId: 'true'
      };
      if (this.classData.length > 0) {
        params.gradeId = this.classData[0];
        this.classData[1] ? params.classId = this.classData[1] : '';
      }
      try {
        this.loadingStudent = true;
        const res = await courseSchedulCenter.getClassPartitionStudents(params);
        if (res.status === 200) {
          const enrollIds = this.selectStudentData.map(item => { return item.id; });
          console.log(enrollIds, '入班id');
          this.studentsData = res.message.list.map(item => {
            if (enrollIds.includes(item.id)) {
              item._checked = true;
            } else {
              item._checked = false;
            }
            item.registeredTimeShow = item.registeredTime ? item.registeredTime.split(' ')[0] : '';
            return item;
          });
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingStudent = false;
      }
    },
    // 选择某一行
    selectRow(row, index) {
      this.$refs.studentTable.toggleSelect(index);
    },
    // 选择一个学生
    pickOneStudent(_, row) {
      console.log(row, '选择学生---');
      this.selectStudentData.push(row);
    },
    // 取消选择一个学生
    cancelOneStudent(_, row) {
      this.selectStudentData = this.selectStudentData.filter(item => {
        return item.id !== row.id;
      });
    },
    // 全选学生
    pickAllStudent(selection) {
      selection.forEach(item => {
        const index = this.selectStudentData.findIndex(x => {
          return x.id === item.id;
        });
        index === -1 ? this.selectStudentData.push(item) : '';
      });
    },
    // 取消全选学生
    cancelAllStudent() {
      this.selectStudentData = this.selectStudentData.filter(item => {
        const index = this.studentsData.findIndex(x => {
          return x.id === item.id;
        });
        return index === -1;
      });
    },

    // 设置入班时间
    handleCloseClassTime() {
      this.toClassShow = false;
    },
    // 修改上课时间
    handleSetAttenTime() {
      this.attendClassShow = true;
    },
    // 修改上课时间
    handleCloseAttenTime() {
      this.attendClassShow = false;
    },
    // 添加备注
    handleAddRemarks() {
      if (this.selectStudentData.length === 0) {
        this.$Message.error('请选择要添加备注的学生！');
        return;
      }
      this.remarksShow = true;
    },
    // 真正的添加备注
    async handleToRemarkTrue() {
      console.log('添加备注===', this.selectStudentData);
      if (this.selectStudentData.length === 0) {
        return;
      }
      try {
        const enrollIds = this.selectStudentData.map(item => {
          return item.id;
        });
        const params = {
          remark: this.remarks,
          enrollIds
        };
        this.remarkLoading = true;
        const res = await courseSchedulCenter.remarkToStudent(params);
        if (res.status === 200) {
          this.$Message.success('添加备注成功！');
          this.handleCloseRemarksModal();
          this.initList();
          this.remarks = '';
          this.selectStudentData = [];
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.remarkLoading = false;
      }
    },
    handleCloseRemarksModal() {
      this.remarksShow = false;
    },
    // 处理学生离班
    handleLeaveStudents() {
      if (this.selectStudentData.length === 0) {
        this.$Message.error('请选择要离班的学生！');
        return;
      }
      this.$nextTick(() => {
        this.$refs.leaveClassModal.openLeaveModal(this.selectStudentData);
      });
    },
    // 离班成功之后
    leaveSuccess() {
      this.$emit('studentChange');
      this.initList();
      this.selectStudentData = [];
    },
    // 转班
    handleChangeStudents() {
      if (this.selectStudentData.length === 0) {
        this.$Message.error('请选择要转班的学生！');
        return;
      }
      console.log('转班的数据---', this.selectStudentData);
      this.$nextTick(() => {
        this.$refs.changeClassDrawerContent.changeClassStepOne(this.selectStudentData);
      });
    },
    // 转班
    // handleChangeStudents() {
    //   if (this.selectStudentData.length === 0) {
    //     this.$Message.error('请选择要转班的学生！');
    //     return;
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.changeClassDrawer.openDrawer();
    //   });
    // },

    // 转班成功更新数据
    changeClassSuccess() {
      this.selectStudentData = [];
      this.getStudentsList();
      this.$emit('studentChange');
    }
  }
};
</script>
<style lang="scss" scoped>
.deal-block {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .student-search {
    margin-right: auto;
    display: flex;
    width: 800px;
    align-items: center;
    .search-btn {
      margin-left: 16px;
    }
  }
}
.table-box {
  margin-top: 24px;
}
.download-icon {
  margin-left: 16px;
  cursor: pointer;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.select-box {
  margin-top: 16px;
}
.modal-footer {
  margin-top: 32px;
  text-align: right;
  button + button {
    margin-left: 16px;
  }
}
.modal-tips {
  color: #488ffa;
  margin-bottom: 16px;
}
.change-tab {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .tab-item {
    border-bottom: 4px solid transparent;
    padding: 4px 8px;
    cursor: pointer;
  }
  .tab-item + .tab-item {
    margin-left: 8px;
  }
  .tab-item-active {
    border-bottom: 4px solid #488ffa;
    color: #488ffa;
    font-weight: 600;
  }
}
.img-block {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
<style lang="scss">
.date-red {
  position: relative;
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: red;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
